import React from "react";
import './customer-invoice-summary.scss';
import {defaultTypography, GSButton, GSImage, GSInfoGroup} from "golfstatus_react_components";
import moment from "moment/moment";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const CustomerInvoiceSummary = ({details, style}) => {

  const isInvoicePaid = () => {
    return details?.registrationOrder?.status === "paid";
  };

  const isInvoiceVoid = () => {
    return details?.registrationOrder?.status === "void";
  };

  const isInvoicePending = () => {
    return details?.registrationOrder?.status === "pending"
  }

  const getPaymentStatus = () => {
    let status = "Unpaid";
    if (isInvoicePaid()) {
      status = "Paid";
    } 
    if (isInvoiceVoid()) {
      status = "Void";
    }
    if (isInvoicePending()) {
      status = "Pending"
    }
    return status;
  };

  const getPaymentStatusDate = () => {
    if (isInvoicePaid() || isInvoicePending()) {
      return `Paid on ${moment(details?.registrationOrder?.invoicePaidAt).format("MMM DD, YYYY")}`;
    } else if (isInvoiceVoid()) {
      return `Voided on ${moment(details?.registrationOrder?.updatedAt).format("MMM DD, YYYY")}`;
    }
    return `Due on ${moment(details?.invoice?.dueDate).format("MMM DD, YYYY")}`;
  };

  const tournamentDetails = {
    fit: "stretch",
    sections: [
      {
        sectionItems: [
          {
            type: "primary small-gap",
            value: <GSImage size="medium wide" src={details?.tournament?.logo} />,
          },
          {
            type: "primary",
            value: <div style={{...defaultTypography.mediumBoldBody}}>{details?.tournament?.name} Invoice</div>
          },
          {
            type: "secondary no-wrap",
            value: details?.organization?.name
          },
        ],
      },
    ],
  };

  const paymentDetails = {
    sections: [
      {
        sectionItems: [
          {
            type: "primary no-wrap right large-gap",
            value: <GSButton title={getPaymentStatus()} buttonIcon={isInvoicePending() ? faSpinner : null} isPill={true} type={isInvoicePaid() ? "green" : "grey"} />,
          },
          {
            type: "secondary no-wrap right",
            value: `Invoice #${details?.customerInvoiceId}`,
          },
          {
            type: "secondary no-wrap right",
            value: `Issued on ${moment(details?.registrationOrder?.createdAt).format("MMM DD, YYYY")}`,
          },
          {
            type: isInvoicePaid() || isInvoicePending() ? "secondary no-wrap right small-gap" : "secondary no-wrap right",
            value: getPaymentStatusDate(),
          },
        ],
      },
    ],
  };

  const getInvoiceInfo = () => {
    let payment = paymentDetails;
    if (isInvoicePaid() || isInvoicePending()) {
      // if customer invoice was marked as paid, these values will be null
      if (details?.registrationOrder?.cardBrand) {
        payment.sections[0].sectionItems.push({
          type: "secondary no-wrap right",
          value: details?.registrationOrder?.cardBrand,
        });
      }
      if (details?.registrationOrder?.last4) {
        payment.sections[0].sectionItems.push({
          type: "secondary no-wrap right",
          value: `Ending in *${details?.registrationOrder?.last4}`,
        });
      }
    }
    let groups = [
      { ...tournamentDetails },
      { ...payment },
    ];

    return (
      <GSInfoGroup dataGroups={groups} listType={"details"} />
    );
  };

  return (
    <customer-invoice-summary style={style}>
      {getInvoiceInfo()}
    </customer-invoice-summary>
  );
};

export default CustomerInvoiceSummary;
